module.exports = __webpack_public_path__ + "img/team-lueneburg.deba5b5a.jpg";